import { useAppDispatch, useAppSelector } from 'app/hooks'
import Container from 'components/shared/Container'
import { ProductContainer } from 'components/shared/container/ProductContainer'
import {
  ITransactionItem,
} from 'components/shared/form/InvoiceForm'
import useWeb from 'hooks/useWeb'
import { getInfoStore, selectInfoStore } from 'modules/organize/store/redux'
import { useEffect, useRef, useState } from 'react'
import PriceChangeRoundedIcon from '@mui/icons-material/PriceChangeRounded'
import ReplayRoundedIcon from '@mui/icons-material/ReplayRounded'
import { IconButton } from '@mui/material'
import useTheme from 'hooks/useTheme'
import { ProductForm } from '../cashing/ProductForm'
import { DrawerForm } from '../cashing/DrawerForm'
import { PaymentForm } from './PaymentForm'
import useAuth from 'hooks/useAuth'
import useNotify from 'hooks/useNotify'
import { InvoiceForm } from './InvoiceForm'
import { BarcodeReader } from 'components/shared/barcode/BarcodeReader'
import { getListCodeProduct, selectListCodeProduct } from 'shared/redux'

export const Cashing = ({ id = null, transactions = [], customer, paymentData = null, onReload }: any) => {
  const { user } = useAuth()
  const { notify } = useNotify()
  const { device } = useWeb()
  const dispatch = useAppDispatch()
  const { data: preview } = useAppSelector(selectInfoStore)
  const [paymentId, setPaymentId] = useState(id)
  const [payment, setPayment] = useState(paymentData)
  const { data: listCode } = useAppSelector(selectListCodeProduct)
  const [productDialog, setProductDialog] = useState<any>({
    open: false,
    productId: null,
  })
  
  const [drawerDialog, setDrawerDialog] = useState({ open: false })
  const [paymentDialog, setPaymentDialog] = useState<any>({
    open: false,
    payment: null,
    customer: customer,
  })
  const { theme } = useTheme()
  const [transaction, setTransaction] = useState<ITransactionItem | null>(null)
  const [reload, setReload] = useState(false)
  const [disableProduct, setDisableProduct] = useState(true)
  const [table, setTable] = useState('--');

  useEffect(() => {
    dispatch(getInfoStore())
    dispatch(getListCodeProduct())
  }, [dispatch])

  useEffect(() => {
    setPayment(paymentData)
  }, [paymentData])
  
  useEffect(() => {
    setPaymentId(id)
  }, [id])

  useEffect(() => {
    setPaymentDialog(prev => ({ ...prev, customer }))
  }, [customer])

  useEffect(() => {
    if (!payment) setDisableProduct(true)
    let isCompleted = payment?.status
    setDisableProduct(isCompleted)
    setPaymentDialog(prev => ({ ...prev, payment }))
  }, [payment])
  
  const handleClickProduct = (id) => {
    setProductDialog({ ...productDialog, productId: id })
  }

  const handlePayment = (data) => {
    if (data.transactions.length < 1)
      return notify('No transaction added', 'error')
    if (paymentDialog.payment) {
      return setPaymentDialog({ ...paymentDialog, open: true })
    }
  }

  const handleChangeCustomer = (data) => {
    setPaymentDialog({ ...paymentDialog, customer: data })
  }

  const invoiceRef = useRef<any>()
  const handleClearPayment = () => {
    onReload()
  }

  const handleChangePayment = (data) => {
    setPaymentDialog({
      ...paymentDialog,
      payment: data,
    })
  }

  const handleScanProduct = (code) => {
    const scannedProduct = listCode.find((item: any) => item.code === code)
    if (!scannedProduct) return
    setProductDialog({ ...productDialog, productId: scannedProduct._id })
  }

  const handleScanError = (msg) => {
    notify(msg, 'error')
  }

  const [stockProducts, setStockProducts] = useState({})
  
  const handleUpdateStock = (data) => {
    setStockProducts(data)
  }

  const handleAddTransaction = (data, stockRemain) => {
    setStockProducts(stockRemain)
    setTransaction({
      id: data._id,
      description: data.description,
      discount: {
        value: data.discount?.value || 0,
        currency: data.discount?.type || 'PCT',
        isFixed: data.discount?.isFixed || false,
      },
      price: { value: data.price, currency: data.currency },
      quantity: data.quantity,
      total: data.total,
      profile: data.product?.profile?.filename,
      hasThermalPrinting: !!data.product?.category?.hasThermalPrinting,
      options: data.options ?? [],
    })
  }

  return (
    <Container>
      <BarcodeReader onScan={handleScanProduct} onError={handleScanError} />
      <ProductForm
        dialog={productDialog}
        setDialog={setProductDialog}
        addTransaction={handleAddTransaction}
      />
      <DrawerForm dialog={drawerDialog} setDialog={setDrawerDialog} />
      <PaymentForm
        dialog={paymentDialog}
        setDialog={setPaymentDialog}
        onClear={handleClearPayment}
        onCheckout={() => setDisableProduct(true)}
      />
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            device === 'mobile' || device === 'tablet' ? '1fr' : '1fr auto',
          gridTemplateAreas:
            device === 'mobile' || device === 'tablet'
              ? `'invoice invoice''product product'`
              : `'product invoice'`,
          gridGap: 30,
          height: 'fit-content',
        }}
      >
        <div style={{ gridArea: 'product' }}>
          <ProductContainer
            onClickProduct={handleClickProduct}
            filterPromotion={true}
            toggleReload={reload}
            updateStocks={stockProducts}
            isDisabled={disableProduct}
            actions={
              <>
                <IconButton
                  onClick={() =>
                    setDrawerDialog({ ...drawerDialog, open: true })
                  }
                  style={{
                    color: user?.drawer?.status
                      ? theme.color.success
                      : theme.color.error,
                    width: 30,
                    height: 30,
                    marginRight: 10,
                  }}
                >
                  <PriceChangeRoundedIcon style={{ fontSize: 23 }} />
                </IconButton>
                <IconButton
                  onClick={() => setReload(!reload)}
                  style={{
                    color: theme.text.secondary,
                    width: 30,
                    height: 30,
                    marginRight: 10,
                  }}
                >
                  <ReplayRoundedIcon style={{ fontSize: 21 }} />
                </IconButton>
              </>
            }
          />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gridArea: 'invoice',
          }}
        >
          <InvoiceForm
            ref={invoiceRef}
            id={paymentId}
            defaultTax={preview?.tax}
            transaction={transaction}
            onUpdate={() => setReload(!reload)}
            onUpdateStock={handleUpdateStock}
            onPayment={handlePayment}
            onChangeCustomer={handleChangeCustomer}
            onChangePayment={handleChangePayment}
            listTransactions={transactions}
            selectedCustomer={customer}
            paymentData={payment}
            table={table}
            setTable={setTable}
            disableForm={disableProduct}
          />
        </div>
      </div>
    </Container>
  )
}
